import { CalendarClock } from "lucide-react";
import { cn } from "@/lib/utils";
import { ESTADO_PROMESA_COLOR, type Promesa } from "./schemas";
import { getTz } from "@/lib/tz";

type Props = {
  promesa: Promesa;
  compact?: boolean;
};

export function PromesaBadge({ promesa, compact = false }: Props) {
  const fecha = new Date(promesa.fecha_prometida).toLocaleDateString("es-MX", {
    timeZone: getTz(),
    day: "2-digit",
    month: "short",
  });
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[10px] font-medium ring-1",
        ESTADO_PROMESA_COLOR[promesa.estado],
      )}
      title={
        promesa.motivo
          ? `Promesa hasta ${promesa.fecha_prometida} — ${promesa.motivo}`
          : `Promesa hasta ${promesa.fecha_prometida}`
      }
    >
      <CalendarClock size={10} />
      {compact ? fecha : `Promesa: ${fecha}`}
    </span>
  );
}
